import React, { useEffect, useState, useCallback } from 'react'
import { Button, makeStyles, Theme, createStyles } from '@material-ui/core'
import MyLocationIcon from '@material-ui/icons/MyLocation'
import kommundata from '../data/kommundata2022'
import { MunicipalityData } from './DropDown'
import { filter } from 'lodash'

interface Props {
    activeMunicipality: MunicipalityData
    setActiveMunicipality: (municipalityData: MunicipalityData) => void
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '& > *': {
                margin: '1vmin',
                width: '30vmin',
            },
        },
    })
)

const filterGeoData = (data: any) => {
    // TODO: handle errors from invalid data and missing fields.
    if (data.status !== 'OK') return ''
    const response: string = data.results
        .filter((result: any) => {
            return result.types.includes('administrative_area_level_2')
        })[0]
        .formatted_address.split(',')[0]
    return response
}

const getPosition = async (
    position: Position,
    setMunicipality: (data: string) => void,
    setActiveMunicipality: (data: MunicipalityData) => void
) => {
    const payload = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&language=sv&key=${process.env.REACT_APP_GOOGLE_GEOCODING_API_KEY}`
    const response = await fetch(payload)
    const data = await response.json()
    //const data = GEO_MOCK_DATA
    const municipality = filterGeoData(data)

    if (municipality && municipality.length > 1) {
        const municipalityObj = filter(kommundata, [
            'municipality',
            municipality,
        ])
        if (municipalityObj.length > 0) {
            setActiveMunicipality(municipalityObj[0])
            setMunicipality(municipality)
        } else {
            setMunicipality('')
        }
    } else {
        setMunicipality('')
    }
}

const GeoButton: React.FC<Props> = (props: Props) => {
    const classes = useStyles()
    const [userLocationSharing, setUserLocationSharing] = useState(false)
    const [municipality, setMunicipality] = useState('')
    const [buttonDisabled, setButtonDisabled] = useState(false)

    const handleGetPosition = useCallback(
        (position: Position) => {
            // Memoized function because we don't want to rebuild it on every render but it still needs access to props and local state.
            getPosition(position, setMunicipality, props.setActiveMunicipality)
        },
        [props.setActiveMunicipality]
    )
    useEffect(() => {
        if (!userLocationSharing) return
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(handleGetPosition)
        } else {
            setUserLocationSharing(false)
        }
    }, [userLocationSharing, handleGetPosition])

    useEffect(() => {}, [municipality])

    return (
        <>
            <Button
                className={classes.root}
                disabled={buttonDisabled}
                variant="contained"
                onClick={() => {
                    setUserLocationSharing(true)
                    setButtonDisabled(true)
                }}
                color="default"
                startIcon={<MyLocationIcon />}
            >
                {buttonDisabled
                    ? 'Ladda om sidan för att söka igen'
                    : 'Sök på min position'}
            </Button>
        </>
    )
}

export default GeoButton
